import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';

// TODO: remove URL from schema and refactor s3-files service.
export const FILE_SCHEMA = Object.freeze({
  ID: null, // ''
  URL: null, // not in server response
  MIME_TYPE: null,
  FILE_SIZE: 0,
});

const RECORD = generateSchema(FILE_SCHEMA);
const KEYS: any = generateKeys(FILE_SCHEMA);

export class File extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    // This is NOT a good practice, the reason for using this approach:
    // 1.we cannot have the property size in an immutable record because size is a reserved property
    // 2.it is complicated for backend to return another key other than size now, it might break something in prod
    props = props && props.toMap ? props.toMap() : fromJS(props || {});
    if (props.get('size')) {
      const size = props.get('size');
      props.delete('size');
      super(props);

      const selfModel = setInModel(this, [
        {
          key: KEYS.FILE_SIZE,
          value: size,
        },
      ]);
      return selfModel as File;
    } else {
      super(props);
    }
  }

  get id() {
    return this.get(KEYS.ID);
  }

  get url() {
    return this.get(KEYS.URL);
  }

  get mimeType() {
    return this.get(KEYS.MIME_TYPE);
  }

  get fileSize() {
    return this.get(KEYS.FILE_SIZE);
  }

  serialize(): File {
    return this.toMap()
      .set('size', this.get(KEYS.FILE_SIZE))
      .remove(KEYS.URL) as File;
  }
}
